const markdownToHtml = (text: string, classes = "underline-offset-1 decoration-2 font-medium underline"): string => {
  const bold = /\*\*(.*?)\*\*/gm;
  const html = text.replace(bold, `<strong class="${classes}">$1</strong>`);
  return html;
};

export { markdownToHtml };
